import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { FocusEvent, ReactNode } from "react";

import css from "./dropdown.module.scss";

type CreateButtonProps = {
  onClick: VoidFunction;
  onBlur: (event: FocusEvent<HTMLDivElement>) => void;
  label?: string;
  tooltipContent?: ReactNode;
};

export const CreateButton = ({ onClick, onBlur, label, tooltipContent }: CreateButtonProps) => {
  const button = (
    <Button
      className={css.createButton}
      text={label}
      icon="add"
      kind="text"
      onClick={onClick}
      onBlur={onBlur}
    />
  );

  if (!tooltipContent) {
    return button;
  }

  return (
    <Tooltip
      triggerContainerProps={{ className: css.createButtonTooltip }}
      content={tooltipContent}
      placement="bottom"
    >
      {button}
    </Tooltip>
  );
};
